import { Brand, createBranded } from '@deltasierra/type-utilities';

export type IntegrationConfigurationId = Brand<number, 'IntegrationConfigurationId'>;
export const IntegrationConfigurationId = createBranded<IntegrationConfigurationId>();
